import FootSideEnum from '@/domains/scan/typescript/enums/FootSideEnum';
import ModeEnum from '@/3d-app/scan/ModeEnum';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type ViewerStepInterface from '@/domains/viewer/typescript/interfaces/ViewerStepInterface';

const DEFAULT_SCAN_OPACITY_IN_PERCENT = 80;
const DEFAULT_SOLE_OPACITY_IN_PERCENT = 80;
const DEFAULT_OPACITY_IN_PERCENT = 100;

export default defineStore('viewer', () => {
    const currentStep = ref<ViewerStepInterface>();
    const selectedFoot = ref<FootSideEnum>(FootSideEnum.Left);
    const steps = ref<ViewerStepInterface[]>([]);

    const currentMode = ref<ModeEnum>();

    const scanSliderValue = ref<number>(DEFAULT_SCAN_OPACITY_IN_PERCENT);
    const soleSliderValue = ref<number>(DEFAULT_SOLE_OPACITY_IN_PERCENT);
    const templateSliderValue = ref<number>(DEFAULT_OPACITY_IN_PERCENT);

    const element3dSliderValue = ref<number>(DEFAULT_OPACITY_IN_PERCENT);
    const holling3dSliderValue = ref<number>(DEFAULT_OPACITY_IN_PERCENT);
    const engravingSliderValue = ref<number>(DEFAULT_OPACITY_IN_PERCENT);
    const morphingSliderValue = ref<number>(DEFAULT_OPACITY_IN_PERCENT);

    const has3DChanged = ref(false);
    const isSaving = ref(false);
    const isLoading = ref(false);
    const loadingMessage = ref<string>();

    function $reset() {
        console.info('reset viewer store');
        currentStep.value = undefined;
        has3DChanged.value = false;
        isSaving.value = false;
        isLoading.value = false;
        // resetAllStores() relies on this function to leave nothing of the previous session
        // behind, so it resets the whole viewer state and not only the flags.
        selectedFoot.value = FootSideEnum.Left;
        steps.value = [];
        currentMode.value = undefined;
        loadingMessage.value = undefined;
        scanSliderValue.value = DEFAULT_SCAN_OPACITY_IN_PERCENT;
        soleSliderValue.value = DEFAULT_SOLE_OPACITY_IN_PERCENT;
        templateSliderValue.value = DEFAULT_OPACITY_IN_PERCENT;
        element3dSliderValue.value = DEFAULT_OPACITY_IN_PERCENT;
        holling3dSliderValue.value = DEFAULT_OPACITY_IN_PERCENT;
        engravingSliderValue.value = DEFAULT_OPACITY_IN_PERCENT;
        morphingSliderValue.value = DEFAULT_OPACITY_IN_PERCENT;
    }

    return {
        currentStep,
        selectedFoot,
        steps,
        has3DChanged,
        isSaving,
        isLoading,
        loadingMessage,
        scanSliderValue,
        soleSliderValue,
        templateSliderValue,
        element3dSliderValue,
        holling3dSliderValue,
        engravingSliderValue,
        morphingSliderValue,
        currentMode,
        $reset,
    };
});
